import { Action, createReducer, on } from "@ngrx/store";
import * as customerAction from "./customer.actions";
import * as settingAction from "../../settings/ngrx/settings.action";
import { CustomerDto } from "../interfaces/customer_dto";
import { getPlan } from "src/app/shared/models/plans.enum";
export const customerFeatureKey = "customer";

export interface State {
    customer: CustomerDto | null;
    entitlements: string[] | null;
    platformPurchase: string | null;
    isLoaded: boolean;
}

export const initialState: State = {
    customer: null,
    entitlements: null,
    platformPurchase: null,
    isLoaded: false
};

const customersReducer = createReducer(
    initialState,
    on(customerAction.loadCustomer,
        state => ({ ...state, isLoaded: false })
    ),
    on(customerAction.loadCustomerSuccess,
        (state, { customer }) => ({ ...state, customer, isLoaded: true })
    ),
    on(customerAction.updateCustomerEntitlements,
        (state, { entitlements }) => ({ ...state, entitlements: entitlements.map(entitlement => getPlan(entitlement)) })
    ),
    on(customerAction.updateCustomerPlatformPurchase,
        (state, { platformPurchase }) => ({ ...state, platformPurchase })
    ),
    on(customerAction.updateCustomerSuccess,
        (state, { customer }) => ({ ...state, customer })
    ),
    on(settingAction.disconnectGoogleCalendarSuccess,
        (state, { customer }) => ({ ...state, customer })
    ),
    on(settingAction.disconnectLocalCalendarSuccess,
        (state, { customer }) => ({ ...state, customer })
    )
);

export function customerReducer(
    state: State | undefined,
    action: Action
) {
    return customersReducer(state, action);
}
